<template>
  <div class="home centered">

    <div id="genres" v-show="searcProps.genres_show" class="noselect">
        <a :class="{active: genre.active}" v-for="(genre) in genresList" v-text="genre.name" :key="genre.id" @click="pushOrPull(searcProps.genres, genre.id); genre.active=!genre.active;"></a>
    </div>

    <div id="items_list" :class="{ albums: searcProps.is_album }">

    <div id="search_head">
        <h1 v-if="searcProps.q != ''">תוצאות עבור: <b v-text="searcProps.q"></b></h1>
        <h1 v-else-if="searcProps.is_album">אלבומים שחייבים לשמוע</h1>
        <h1 v-else-if="searcProps.type == 9">קליפים שחייבים לשמוע</h1>
        <h1 v-else-if="!isNull(searcProps.date_from)">לינקטונים מתאריך {{ formatDate(searcProps.date_from) }} עד {{formatDate(searcProps.date_to)}}</h1>
        <h1 v-else>לינקטונים שחייבים לשמוע</h1>

        <template v-if="is_mobile()">
          <a id="filter_btn" @click="showFilters=true"><i class="fas fa-filter"></i></a>

        </template>

    </div>
    
    <template v-if="is_mobile()">
      <div>
        <Popup v-model="showFilters">
          <template #title>חיפוש לינקטונים</template>
          <template #content><CatalogFilters :searcProps="searcProps" /></template>
          

          <template #actions>
            <a class="md-primary" @click="showFilters = false">הצג תוצאות</a>
            <!-- <a class="md-primary" @click="showDialog = false">Save</a> -->
          </template>
        </Popup>

      </div>
    </template>
      
      <template v-if="artists.length == 1">
        <ArtistItem v-for="artist in artists" :key="artist.id" :item="artist" />
      </template>

    <div class="items_list">
      <div class="item_wrapper"  v-for="item in items" :key="item.id">
        <drag :key="item.id" class="drag" :data="item" :disabled="is_mobile()" :delay="20">
          <CatalogItem :item="item" @play="$emit('play', item)" @open_widget="$emit('open_widget', item)" />
        </drag>
      </div>
    </div>
      
      <Loader v-if="on_loading" />

    </div>
    
  </div>
</template>

<script>

import CatalogFilters from '@/components/catalog/filters.vue'
import CatalogItem from '../components/catalog/item.vue';
import ArtistItem from '../components/catalog/artist_item.vue'; 
import Loader from '../components/loader.vue';

import { Drag } from "vue-easy-dnd";

export default {
  props: ["searcProps"],
  components: { CatalogItem, ArtistItem, Drag, Loader, CatalogFilters},
  data(){
    return {
      artists: [],
      items: [],
      on_loading: false,
      page: 0,
      searchTimer: null,
      xhr: false,
      showFilters: false,
      genresList: this.$store.genres.map((row) => { row.active = false; return row; })
    }
  },
  methods: {
    onDrop(e) {
      this.dropped.push(e.data);
    },
    load_results(){
      
      this.artists = [];
      //if (this.on_loading) return;
      
      this.page++;

      if (this.page == 1) 
      {
        this.items = [];
      }

      this.on_loading = true;
      if (this.xhr) this.xhr.cancel();
      this.xhr = this.api({ action: 'vod/results', data: { page: this.page,mixed_results: this.searcProps.mixed_results, genre: this.searcProps.genres, date_from: this.searcProps.date_from, date_to: this.searcProps.date_to, q: this.searcProps.q, type: this.searcProps.type, is_album: this.searcProps.is_album} }, (data) => { 
        
        this.parse_items(data.data.items);
        
        if (this.page == 1) this.artists = data.data.artists || [];
        if (this.page == 1) this.items = data.data.items; 
        else this.items.push(...data.data.items); 
        this.on_loading = false;
      });

    }
  },
  mounted(){
    this.load_results();
  
    window.onscroll = () => {
      if  (!this.on_loading && document.documentElement.scrollTop + 400 >= (document.body.scrollHeight - window.innerHeight ))
			{
        this.load_results();
      }
    };
  },

  watch:{
    searcProps: {
      deep: true,
      handler(){ 
        this.page = 0;
        this.items = [];
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
          this.load_results();
        }, 200);
        
      }
    }
  }
  
}
</script>

<style lang="scss">

#items_list { 
  h1 { font-size: 28px; color: #333; margin-bottom: 15px;}
}

#genres { display: flex; gap:10px; flex-wrap: wrap; margin-bottom: 25px;
  a { display: inline-block; padding: 0 15px; height: 55px; line-height: 55px; border-radius: 16px; border: solid 1px rgba(33, 37, 48, 0.3); color:rgba(33, 37, 48, 0.3); }
  a.active { background: #ff256e; color: #fff; font-weight: bold;   box-shadow: 0 12px 24px -10px #c12a5f; }
}

.droparea { width:500px; height: 100px; overflow: hidden; }
.drag-source {
  border-radius: 33px;
  background-color: #d8d8d8;
  transition: all 0.5s;
  .item { opacity: 0;}
}
.drop-allowed {
  background-color: rgba(0, 255, 0, 0.2);
}

.drag-in-progress body > .dnd-drag{ 
  opacity: 0.9 !important; 
  .item { 
    &{ transform: rotate(-10deg) !important;   box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.23) !important; }
    .play_btn { display: none !important; }
  }
}


.artist_item {
  & { width:40%; float: right; padding:10px; }
}

 #items_list.albums .items_list {

  @media (min-width: 600px) {display: grid;grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));}
  @media (max-width: 600px) {display: grid;grid-template-columns: repeat(2, 1fr);padding-top: 60px;}
  .item_wrapper{width: auto;float: none;}


  .item .pic { padding-bottom: 100%;}

}

#search_head {
  @media (max-width: 600px) { 
    &{ position: fixed; top: 64px; left: 0px; right: 0px; background:#fff; z-index: 999; display: flex; justify-content: space-between; padding:0 15px; }
    #filter_btn { 
      svg { color: #333;}
    }
  }
}

@media (max-width: 600px) { 
  .items_list { padding-top: 40px;}
}
</style>